import Vue from "vue";
import App from "@/App.vue";
//import Router from 'vue-router'
import router from "@/router";
import VueMq from "vue-mq";
import VueKeepScrollPosition from "vue-keep-scroll-position";

Vue.use(VueKeepScrollPosition);

Vue.config.productionTip = false;
Vue.config.devtools = true;

//Vue.use(Router)
Vue.use(VueMq, {
    breakpoints: {
        // default breakpoints - customize this
        sm: 738,
        md: 1101,
        lg: 1440,
        xlg: 1900,
        xxlg: Infinity,
    },
    defaultBreakpoint: "sm", // customize this for SSR
});

router.beforeEach((to, from, next) => {
    if (from.name != null) {
        from.meta.scrollPos = document.querySelector("#content").scrollTop;
    }
    return next();
});

router.afterEach((to, from) => {
    if ("scrollPos" in to.meta) {
        // setTimeout(function () {
        //     document.querySelector("#content").scrollTop = to.meta.scrollPos;
        // }, 10);
    }
});

const vue = new Vue({
    router,
    render: (h) => h(App),
});

vue.$mount("#app");
